import { toFixed } from '../../../core/services/utils/numbers';

/** Calcula o percentual de evolução do pretendido/projetado sobre o realizado no ano anterior */
export function calcularPercEvolucao(realizadoAnoAnterior: number, pretendidoProjetado: number): number {
    realizadoAnoAnterior = realizadoAnoAnterior && !isNaN(realizadoAnoAnterior) ? Number(realizadoAnoAnterior) : 0;
    pretendidoProjetado = pretendidoProjetado && !isNaN(pretendidoProjetado) ? Number(pretendidoProjetado) : 0;

    if (realizadoAnoAnterior === 0 && pretendidoProjetado === 0) { // Realizado ano anterior e pretendido/projetado zeroz => 0% de evolução
        return 0;
    } else if (realizadoAnoAnterior === 0) { // Somente realizado ano anterior zero => 100% de evolução
        return 100;
    }

    const percEvolucao = ( (pretendidoProjetado - realizadoAnoAnterior) / realizadoAnoAnterior ) * 100;
    return toFixed(percEvolucao, 2)
}
